import React from 'react';
import { DURATION, SVG_CIRCUMFERENCE, SVG_SIZE, ROTATION_TRANSFORM, SVG_CENTER, SPINNER_RADIUS, SPINNER_ROTATION_DEGREES, SPINNER_DASHARRAY_MIN, SPINNER_DASHARRAY_MAX, SPINNER_KEYTIMES, SPINNER_DASHARRAY_HALF, SPINNER_DASHOFFSET_FACTOR, propTypes } from './shared';
import { useA11yInfo } from '../A11yInfoProvider';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const animateProps = {
  keyTimes: SPINNER_KEYTIMES,
  repeatCount: 'indefinite'
};
const Spinner = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    size,
    color,
    indicatorBackgroundColor,
    thickness,
    label,
    isStatic = false
  } = _ref;
  const {
    reduceMotionEnabled
  } = useA11yInfo();
  const reduceMotion = reduceMotionEnabled || isStatic;
  const strokeWidth = thickness * SVG_SIZE / size;
  return /*#__PURE__*/_jsxs("svg", {
    ref: ref,
    width: `${size}px`,
    height: `${size}px`,
    viewBox: `0 0 ${SVG_SIZE} ${SVG_SIZE}`,
    "aria-valuetext": label,
    role: "progressbar",
    "aria-busy": "true",
    children: [/*#__PURE__*/_jsx("circle", {
      fill: "none",
      stroke: indicatorBackgroundColor,
      strokeWidth: strokeWidth,
      cx: SVG_CENTER,
      cy: SVG_CENTER,
      r: SPINNER_RADIUS
    }), /*#__PURE__*/_jsx("circle", {
      fill: "none",
      stroke: color,
      strokeWidth: strokeWidth,
      strokeLinecap: "round",
      cx: SVG_CENTER,
      cy: SVG_CENTER,
      r: SPINNER_RADIUS,
      strokeDasharray: `${SPINNER_DASHARRAY_MIN * SVG_CIRCUMFERENCE}, ${SPINNER_DASHARRAY_MAX * SVG_CIRCUMFERENCE}`,
      strokeDashoffset: "0"
      // Circle rotated -90° so that 0% is at the top (12 o'clock).
      ,
      transform: ROTATION_TRANSFORM,
      children: reduceMotion ? null : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("animateTransform", {
          attributeName: "transform",
          type: "rotate",
          from: "0 24 24",
          to: `${SPINNER_ROTATION_DEGREES} ${SVG_CENTER} ${SVG_CENTER}`,
          dur: `${DURATION}ms`,
          repeatCount: "indefinite",
          additive: "sum"
        }), /*#__PURE__*/_jsx("animate", {
          attributeName: "stroke-dasharray",
          dur: `${DURATION}ms`,
          values: `
                  ${SPINNER_DASHARRAY_MIN * SVG_CIRCUMFERENCE},${SPINNER_DASHARRAY_MAX * SVG_CIRCUMFERENCE};
                  ${SPINNER_DASHARRAY_HALF * SVG_CIRCUMFERENCE},${SPINNER_DASHARRAY_HALF * SVG_CIRCUMFERENCE};
                  ${SPINNER_DASHARRAY_MIN * SVG_CIRCUMFERENCE},${SPINNER_DASHARRAY_MAX * SVG_CIRCUMFERENCE}
                `,
          ...animateProps
        }), /*#__PURE__*/_jsx("animate", {
          attributeName: "stroke-dashoffset",
          dur: `${DURATION}ms`,
          values: `
                  0;
                  0;
                  -${SPINNER_DASHOFFSET_FACTOR * SVG_CIRCUMFERENCE}
                `,
          ...animateProps
        })]
      })
    })]
  });
});
Spinner.displayName = 'Spinner';
Spinner.propTypes = propTypes;
export default Spinner;